<template>
  <a-select
    mode="multiple"
    v-model:value="valueState"
    style="width: 300px"
    placeholder="Pilih Provinsi"
    allow-clear
    :not-found-content="loading ? undefined : 'Tidak ditemukan'"
    option-filter-prop="label"
    option-label-prop="label"
    @search="onSearch"
    @blur="() => (findText = null)"
    @select="() => (findText = null)"
    v-bind="$attrs"
    :loading="loading"
    :show-arrow="true"
  >
    <a-select-option v-for="(d, index) in data" :key="index" :value="d.id" :label="d.name">
      <!-- eslint-disable vue/no-v-html -->
      <span v-html="highlight(d.name)"></span>
      <!--eslint-enable-->
    </a-select-option>
    <template v-if="loading" #notFoundContent>
        <ASpin size="small" />
    </template>
  </a-select>
</template>

<script>
import { onMounted, ref, watch, toRefs, reactive } from 'vue'
import apiClient from '@/services/axios'
import { useVModel } from '@/components/useVModel.js'
import { debounce } from 'lodash'

export default {
  props: {
    value: {
      default: () => [],
      type: Array,
    },
    region: {
      default: () => [],
      type: Array,
    },
    alone: [Boolean],
  },
  emits: ['update:value'],
  setup(props, { emit }) {
    const data = ref([])
    const findText = ref(null)
    const { region, alone } = toRefs(props)

    const state = reactive({
      loading: false,
    })

    const fetchData = debounce((region) => {
      if (!alone && region.length <= 0) region = [-1]
      state.loading = true
      apiClient
        .get('/api/filter/wilayah-by-role/1', { params: { region: region } })
        .then(response => {
          const sorted = response.data
          data.value = sorted.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))
        })
        .finally(() => {
          state.loading = false
        })
    }, 300)

    onMounted(() => {
      fetchData(region.value)
    })

    watch(region, (after, before) => {
      fetchData(after)
    })

    const onSearch = value => {
      findText.value = value
    }

    const highlight = value => {
      return value.replace(new RegExp(findText.value, 'gi'), match => {
        return `<span style="background-color: yellow;">${match}</span>`
      })
    }

    return {
      data,
      valueState: useVModel(props, 'value'),
      findText,
      highlight,
      onSearch,
      ...toRefs(state),
    }
  },
}
</script>

<style></style>
